import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const strongStartBadgeDefinition: BoggleBadgeDefinition = {
  category: 'speed',
  description: 'Play 5 words in the first 10 seconds',
  iconId: 'flag',
  id: 'strongStart',
  level: 'uncommon',
  lockedReveal: 'reveal',
  name: 'Strong Start',
  points: getBoggleBadgePointsForLevel('uncommon'),
}
